import { type Theme } from "@mui/material"
import { OffersCarouselTheme } from "core/themes/src/definitions/components.types"

export const createOffersCarouselTheme = (_: Theme): OffersCarouselTheme => ({
    styleOverrides: {
        root: {
            height: 470,
        },
    },
})
